export default __webpack_public_path__ + "static/media/html-negative.8c4c6cb5.svg";